import { render } from "./HowItWorksSection.vue?vue&type=template&id=18bf7978&scoped=true"
import script from "./HowItWorksSection.vue?vue&type=script&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=18bf7978&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bf7978"]])

export default __exports__